package hk.com.vr360_demo2.webapp.component.editor_rewrite.component

import emotion.react.css
import kotlinx.browser.window
import react.FC
import react.Key
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import web.cssom.AlignItems
import web.cssom.Background
import web.cssom.Color
import web.cssom.Cursor
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.JustifyContent
import web.cssom.Position
import web.cssom.pct
import web.cssom.px
import kotlin.js.Date
import kotlin.js.json
import kotlin.js.unsafeCast

private data class EditorActionItem(
    val label: String,
    val key: String,
)

private val editorActions = listOf(
    EditorActionItem(label = "項目資料", key = "projectInfo"),
    EditorActionItem(label = "場景", key = "scene"),
    EditorActionItem(label = "初始視角", key = "initialView"),
    EditorActionItem(label = "熱點", key = "hotspot"),
    EditorActionItem(label = "預覽", key = "preview"),
)

external interface EditorRightActionPanelProps : Props {
    var activeAction: String?
    var onActionClick: ((String) -> Unit)?
}

val EditorRightActionPanel = FC<EditorRightActionPanelProps> { props ->
    div {
        css {
            position = Position.absolute
            right = 16.px
            top = 120.px
            zIndex = 30.asDynamic()
            width = 112.px
            display = Display.flex
            flexDirection = FlexDirection.column
            asDynamic().gap = "8px"
            asDynamic().padding = "16px 8px"
            asDynamic().borderRadius = "8px"
            background = "rgba(0, 0, 0, 0.55)".unsafeCast<Background>()
            asDynamic().pointerEvents = "auto"
            asDynamic().backdropFilter = "blur(2px)"
        }

        editorActions.forEach { actionItem ->
            val isActive = props.activeAction == actionItem.label
            button {
                key = actionItem.key.unsafeCast<Key>()
                onClick = {
                    props.onActionClick?.invoke(actionItem.label)
                    val message = json(
                        "source" to "from360",// 这个也固定，不要改
                        "type" to "EDITOR_ACTION_CLICK",
                        "action" to actionItem.key,
                        "actionLabel" to actionItem.label,
                        "timestamp" to Date().toISOString(),
                    )
                    window.parent?.postMessage(message, "*")
                }
                css {
                    width = 100.pct
                    height = 36.px
                    asDynamic().border = "none"
                    background = "transparent".unsafeCast<Background>()
                    color = Color(if (isActive) "#f26522" else "#ffffff")
                    display = Display.flex
                    alignItems = AlignItems.center
                    justifyContent = JustifyContent.center
                    fontSize = 14.px
                    asDynamic().fontWeight = "500"
                    cursor = Cursor.pointer
                    asDynamic().transition = "all .16s ease"
                    hover {
                        color = Color("#f26522")
                    }
                }
                +actionItem.label
            }
        }
    }
}
